export { ModalFooter } from './Footer';
